import { styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  gap: 12,
  paddingBottom: 24,
}));

export const SearchWrapper = styled('div')(() => ({
  width: 250,
}));

export const Greedy = styled('div')(() => ({
  flexGrow: 13,
}));
